<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			
			<el-form :inline="true" :model="filters" size="mini">
				<el-form-item label="项目名称">
					<el-select v-model="filters.projectId" placeholder="请选择项目名称" filterable  @change="getDevices">
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="设备编码" v-if="type==0">
					<el-select v-model="filters.mn"  multiple collapse-tags  @change="getMns" filterable reserve-keyword :filter-method="filterChangeMN" style="width:300px" >
                        <el-option value="全选" label="全选"></el-option>
                        <el-option value="取消全选" label="取消全选"></el-option>
						<el-option
							v-for="item in devicesFil"
							:label="item.mnCode"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="点位名称">
					<el-select v-model="filters.mn"  multiple collapse-tags  @change="getMns" filterable reserve-keyword :filter-method="filterChangeName" style="width:300px" >
                        <el-option value="全选" label="全选"></el-option>
                        <el-option value="取消全选" label="取消全选"></el-option>
						<el-option
							v-for="item in devicesFil"
							:label="item.name"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="连接状态">
					<el-select v-model="filters.status" placeholder="请选择连接状态" >
						<el-option label="离线" value="0"></el-option>
						<el-option label="在线" value="1"></el-option>
						<el-option label="停用" value="99"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<my-button  @select-type="clickBtn" QueryButtonShow ResetButtonShow></my-button>
				</el-form-item>
			</el-form>
		</el-col>
		<el-table :data="dataList" border highlight-current-row v-loading="listLoading"  style="width:100%;" :height="formHeight"  size="mini" ref="table">
			<el-table-column type="index" label="序号"  ></el-table-column >
			<!-- <el-table-column  prop="projectName" label="项目名称"  width="120" fixed></el-table-column> -->
			<el-table-column  prop="deviceName" label="点位名称"    sortable>
				<template slot-scope="scope">
					<span class="styleA" @click="getDeviceinfo(scope.row)">{{scope.row.deviceName}}</span>
				</template>
			</el-table-column>
			<el-table-column  prop="mn" label="设备编码"  sortable  v-if="type==0"></el-table-column>
			<el-table-column prop="status" label="连接状态" >
				<template slot-scope="scope">
					<span v-if="scope.row.status=='1'" style="color:green">在线</span>
					<span v-else-if="scope.row.status=='0'" style="color:red">离线</span>
					<span v-else-if="scope.row.status=='99'" style="color:red">停用</span>
				</template>
			</el-table-column>
			<el-table-column prop="time" label="监测时间"  >
				<template slot-scope="scope">
					<span v-if="scope.row.time==null"></span>
					<span v-else >{{scope.row.time}}</span>
				</template>
			</el-table-column>
			<el-table-column
				v-for="item in facList"
				:prop="item.keyWord"
				:label="item.remark"  :key="item.keyWord" sortable>
				<template slot-scope="scope">
					<span v-if="scope.row[item.keyWord]==null" >{{"-"}}</span>
					<span v-else >
						{{scope.row[item.keyWord]}}
					</span>
				</template>
			</el-table-column>
		</el-table>
		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="pageSize" :total="total" style="float:right;" :page-sizes="[50,100,200,500,1000]"   @size-change="handleSizeChange" :current-page.sync="page" >
			</el-pagination>
		</el-col>

		<el-dialog  title="详情" :visible.sync="deviceDataVisible" :close-on-click-modal="false">

			<div style="overflow:hidden;">
				<el-descriptions title="噪声子站详情" direction="vertical" :column="3" border style="float: left;width:60%;">
					<el-descriptions-item label="点位名称" :span="2">{{chooseDevice.deviceName}}</el-descriptions-item>
					<el-descriptions-item label="点位编码">{{chooseDevice.mn}}</el-descriptions-item>

					<el-descriptions-item label="经度" :span="2">{{chooseDevice.longitude}}</el-descriptions-item>
					<el-descriptions-item label="纬度">{{chooseDevice.latitude}}</el-descriptions-item>

					<el-descriptions-item label="功能区类别" >{{chooseDevice.funName}}</el-descriptions-item>
					<el-descriptions-item label="昼间限值" >{{chooseDevice.ld}}</el-descriptions-item>
					<el-descriptions-item label="夜间限值">{{chooseDevice.ln}}</el-descriptions-item>

					<el-descriptions-item label="生产厂商">{{chooseDevice.manufacturerName}}</el-descriptions-item>
					<el-descriptions-item label="运维电话" >{{chooseDevice.operationCompanyPhone}}</el-descriptions-item>
					<el-descriptions-item label="运维周期" >{{chooseDevice.operationcompanyCycle}}天</el-descriptions-item>

				</el-descriptions>

				<div style="float: left;width:37%;margin-left: 2%; margin-top: 4%;">
					<el-image  style="width: 100%;max-height: 90%;" :src="imgurl"  :preview-src-list="srcList" v-if="imgurl!=''">  </el-image>
					<div v-else>暂无图片</div>
				</div>
			</div>
		

			<el-descriptions title="最近24小时部分事件展示"  :column="3" border style="margin-top: 30px;">
				<template v-for="item in eventList">
					<el-descriptions-item  label="时间"> {{item.time}}  </el-descriptions-item>
					<el-descriptions-item  label="类型"> {{item.type}} </el-descriptions-item>
					<el-descriptions-item  label="偏差/事件"> {{item.remark}} </el-descriptions-item>
				</template>
			</el-descriptions>
		</el-dialog>
	</section>
</template>

<script>
	import { getProjects,getRealDataList,getDevicesByProjectId,getFunctionalAreaList,getEventList,getDeviceList,getDevicePic} from '../../api/api';
	import {in_array,formatDate,setDeviceEvent } from '../../../static/fun.js';

	import myButton from '../../components/myButton/index.vue'
	import TableQueryButton from '../../components/myButton/TableQueryButton.vue'

	export default {
	components: { myButton ,TableQueryButton},
		data() {
			return {
				filters: {
					projectId: '',
					mn:'',
					datatype:'minute',
					status:''
				},
				total: 0,
				pageSize:50,
				page:1,
				listLoading: false,
				dataList:[],
				projects:[],
				devices:[],
				devicesFil:[],
				copy:[],
				rate:100,
				facList:[],
				count:0,
				formHeight:0,
				timer:null,
				wuranwu:false,

				type:1,
				functionalAreaMap:new Map(),
				deviceDataVisible:false,
				chooseDevice:{},
				eventList:[],
				imgurl:'',
				srcList:[],
				arrSecond:['n00001'],
				mnMap:new Map(),//记录mn在数组中第几个，方便及时更新数据
				socket:null,
				wsurl:window.configuration.wsUrlSecond,
				socketMN:[],
				chooseMN:[],
				openStatus:false
			}
			
		},
		watch: {
			dataList(val) {
				this.doLayout();
			}
		},
		methods: {
			clickBtn(type){
				if(type=="query"){
					this.getLastDataList();
				}else if(type=="reset"){
					this.reset();
				}
			},
			doLayout(){
				let that = this
				this.$nextTick(() => {
					that.$refs.table.doLayout()
				})
			},
			handleCurrentChange(val) {
				this.page=val;
				this.getLastDataList();
			},
			handleSizeChange(val){
				this.pageSize=val;
				this.getLastDataList();
			},
			getDevicePic(id){
				let para = {
                    deviceId: id
				};
				getDevicePic(para).then((res) => {
					var fileListShow=  res.data.data;
					this.srcList=[];
					fileListShow.forEach(element => {
                        element.url=window.configuration.resourceUrlPhoto+element.urlName;
						this.srcList.push(element.url);
                    });
				
                    if(fileListShow.length>0){
						this.imgurl=fileListShow[0].url;
                    }
				});
            },
			getDeviceinfo(row){
				this.deviceDataVisible=true;
				this.chooseDevice =row;
				var funObj=this.functionalAreaMap.get(row.functionalAreaId);
				this.chooseDevice.ld=funObj.day;
				this.chooseDevice.ln=funObj.night;

				//获取事件信息
				this.eventList=[];
				this.getEventList(0,row.mn);
				this.getEventList(1,row.mn);
				//获取设备信息
				this.getDeviceList(row);
				//获取设备图片
				this.srcList=[];
				this.imgurl="";
				this.getDevicePic(row.deviceId);
			},
			getDeviceList(row) {
				let para = {
                    page: 1,
                    pageSize:1,
                    mnCode: row.mn,
					ProjectId:row.ProjectId
				};
                this.listLoading = true;
				getDeviceList(para).then((res) => {
                    this.listLoading = false;
					if(res.data.data.records.length>0){
						this.chooseDevice = Object.assign(res.data.data.records[0], this.chooseDevice);
					}
				});
			},
			//获取历史数据信息
			getEventList(eventType,mn){
				var end = new Date();
				var start = new Date();
                start.setTime(start.setDate(start.getDate()-1));

				var starttime=formatDate(start);
                var endtime=formatDate(end);

				let para = {
					eventType:eventType,
					page: 1,
					pageSize:3,
                    mn: mn,
					startDate: starttime,
                    endDate: endtime
				};
				getEventList(para).then((res) => {
					var dataList = res.data.data.data;
					if(eventType==0){
						this.checkInfo={};
						if(dataList.length>0){
							for (let index = 0; index < dataList.length; index++) {
								const element = dataList[index];
								element.type='自检';
								element.remark=element.diff;
								element.index=this.eventList.length;
								this.eventList.push(element);
							}
						}
					}else if(eventType==1){
						this.stateInfo={};
						if(dataList.length>0){
							for (let index = 0; index < dataList.length; index++) {
								const data = dataList[index];
								data.remark=setDeviceEvent(data);
								data.type='报警';
								data.index=this.eventList.length;
								this.eventList.push(data);
							}

						}
					}
				
				});
			},
			//获取设备列表
			getDevices() {
				this.listLoading = true;
                let para = {
					projectId: this.filters.projectId.toString()
                };
				getDevicesByProjectId(para).then((res) => {
                    this.listLoading = false;
                    
					this.devices = res.data.data;
					this.devicesFil=res.data.data;
                    this.filters.mn=[];
				});
			},
			filterChangeMN(v){
                this.copy=Object.assign([],this.devices);
                if(!in_array({mnCode:'全选'},this.copy)){
                    this.copy.push( {mnCode:'全选'});
                }
                 if(!in_array({mnCode:'取消全选'},this.copy)){
                    this.copy.push( {mnCode:'取消全选'});
				}
				var dev=v.split(",");

                //对绑定数据赋值
                this.devicesFil = this.copy.filter((item) => {
                    //如果直接包含输入值直接返回true
					if (item.mnCode=="全选"||item.mnCode=="取消全选") return true;
					else if(dev.toString()==""){
						return true;
					}
					else{
						var flag=false;
						dev.forEach(element => {
							if (item.mnCode.indexOf(element) !== -1&&element!="") {
								flag=true;
							}
						});
						return flag;
					}
                })
			},
			filterChangeName(v){
                this.copy=Object.assign([],this.devices);
                if(!in_array({mnCode:'全选'},this.copy)){
                    this.copy.push( {mnCode:'全选'});
                }
                 if(!in_array({mnCode:'取消全选'},this.copy)){
                    this.copy.push( {mnCode:'取消全选'});
				}
				var dev=v.split(",");

                //对绑定数据赋值
                this.devicesFil = this.copy.filter((item) => {
                    //如果直接包含输入值直接返回true
					if (item.mnCode=="全选"||item.mnCode=="取消全选") return true;
					else if(dev.toString()==""){
						return true;
					}
					else{
						var flag=false;
						dev.forEach(element => {
							if (item.name.indexOf(element) !== -1&&element!="") {
								flag=true;
							}
						});
						return flag;
					}
                })
			},
			//获取选中设备
            getMns(){
                // this.getDeviceName();
                if(this.filters.mn.toString()==""){
                    return;
                }
                else if(in_array('取消全选',this.filters.mn)){
                    this.filters.mn=[];
                    return;
                }
                else if(in_array('全选',this.filters.mn)){
                    this.filters.mn=[];
                    this.devicesFil.forEach(element => {
                        this.filters.mn.push(element.mnCode);
                    });
                }
            },
			//查询项目信息
			getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
					this.projects = res.data.data;
					this.listLoading = false;
					if(this.projects.length>0){
						this.filters.projectId=this.projects[0].projectId;
						if(this.count==0){
							this.getDevices();
							this.count=1;
						}
						this.getLastDataList();
                    }
				});
			},
			//条件重置
			reset(){
				this.filters={
					projectId: '',
					mn:'',
					datatype:'minute',
					status:''
				};
			},
			//获取实时数据信息
			getLastDataList(){
				this.type=sessionStorage.getItem("type");
				let para = {
					page: this.page,
					pageSize:this.pageSize,
                    projectId:this.filters.projectId,
					mn: this.filters.mn.toString(),
                    status: this.filters.status
				};
				this.listLoading = true;
				getRealDataList(para).then((res) => {
					this.listLoading = false;
					this.total = res.data.data.total;
					this.dataList = res.data.data.realDatas;

					this.mnMap=new Map();
					this.chooseMN=[];
					if(this.dataList.length>0){
						var i=0;
						this.dataList.forEach(element => {
							var funObj=this.functionalAreaMap.get(element.functionalAreaId);

							var ld=funObj.day;
							var ln=funObj.night;
							var funName=funObj.name;

							element.funName=funName;
							element.ld=ld;
							element.ln=ln;
							this.mnMap.set(element.mn,i);
							this.chooseMN.push(element.mn);
							i++;
						});
					}

					var fac=res.data.data.facList;

					this.facList=[];
					fac.forEach(element => {
						if(in_array(element,this.arrSecond)){
							var obj=JSON.parse(sessionStorage.getItem(element));
							if(obj.unit.trim()!=""){
								obj.remark=obj.remark+'('+obj.unit+')';
							}
							this.facList.push(obj);
						}
					});

					if(!this.openStatus){
						return;//还未连接成功
					}

					if(this.chooseMN.toString()!=this.socketMN.toString()){
						if(this.socketMN.length>0){
							this.closeWsReal(this.socketMN);
						}
						this.openWsReal(this.chooseMN);
					}
				});
			},
			getFunctionalAreaList(){
				getFunctionalAreaList({}).then((res) => {
					res.data.data.forEach(element => {
						this.functionalAreaMap.set(element.id,element);
					});
				});
			},
			SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight+document.getElementsByClassName('toolbar')[1].clientHeight;
				this.formHeight=hgt-titleHgt-toolbarHgt-120;
				if(this.formHeight<300){
					this.formHeight=300;
				}
			},
			websocketInit: function () {
				if(this.socket!=null){
					this.socket.close();
				}
				if (typeof WebSocket === "undefined") {
					alert("您的浏览器不支持socket");
				} else{
					// 实例化socket
					this.socket = new WebSocket(this.wsurl);//ws://xxxxx 
					// 监听socket错误信息
					this.socket.onerror = this.websocketError;
					// 监听socket消息
					this.socket.onmessage = this.websocketGetMessage;
					//连接成功建立的回调方法
					this.socket.onopen = this.websocketOpen;
					this.socket.onclose = this.websocketClose;
				}
			},
			websocketOpen : function(event){
				console.log("socket连接成功");
				this.openStatus=true;
				//防止初次连接后数据未成功发送
				if(this.socketMN.length==0&&this.chooseMN.length!=0){
					this.openWsReal();	
				}
			},
			closeWsReal(socketMN){
				let dataTemp={ "mode":1, "state":0, "mnStr": socketMN.toString() };
				this.websocketSend(JSON.stringify(dataTemp));
			},
			openWsReal(chooseMN){
				// {"mode": 1, "state": 1, "mnStr": "1,2,3,4"}
				// mode 1 声级计 2 频谱   state1开0关
				let dataTemp={ "mode":1, "state":1, "mnStr": chooseMN.toString() };
				this.websocketSend(JSON.stringify(dataTemp));
				this.socketMN=chooseMN;
			},
			websocketClose : function(event){
				console.log("socket连接关闭");
			},
			websocketError: function () {
				console.log("socket连接错误");
			},
			websocketGetMessage: function (msg) {
				//处理数据 msg.data
				var obj=JSON.parse(msg.data);
				if(obj.state!=undefined){//离线报文
					if(obj.mnList==undefined||obj.mnList.length==0){
					}else{
						for (let index = 0; index < obj.mnList.length; index++) {
							const mn = obj.mnList[index];
							var i=this.mnMap.get(mn);
							if(i!=undefined){
								this.dataList[i].status=0;
							}
						}
					}
				}else{
					var mn=obj.mn;
					var i=this.mnMap.get(mn);
					if(i!=undefined){
						this.dataList[i].time=obj.dateTime;
						this.dataList[i].n00001=obj.leq;
						this.dataList[i].status=1;
					}
				}
			},
			websocketSend: function (params) {
				this.socket.send(params);
				console.log("发送数据"+params);
			},
		},
		destroyed() {
			if(this.socketMN.length>0){
				this.closeWsReal(this.socketMN);
			}
			if (this.socket && this.socket.close !== null) {
				this.socket.close();
			}
		},
		mounted() {
			var _this=this;
			var timer2=null;
			clearInterval(timer2);
			timer2 =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer2);
				}
			},10)

			this.websocketInit();
			this.getFunctionalAreaList();
			this.getProjects();
		}
	}

</script>

<style>
	.cell{
		text-align: center;
	}
	.timeFar{
		float: right;
		margin-right: 20px;
	}
	.el-form{
		overflow: hidden;
	}

	.styleA{
		cursor: pointer;
		color: blue;
		text-decoration:underline;
	}
</style>


// WEBPACK FOOTER //
// NormalMap.vue?065e7315